<template>
  <el-table
    :data="items"
    style="width: 100%"
    row-key="id"
    border
  >

    <el-table-column
      prop="name"
      label="Képviselő"
    >

    </el-table-column>



    <el-table-column
      fixed="right"
      label=""
      width="180"
      style="text-align: right;"
    >
      <template
        slot-scope="scope"
      >
        <el-tooltip
          class="item"
          effect="dark"
          content="Módosítás"
          placement="top"
          v-can="'tourcalendarrules.update'"
        >
          <el-button
            size="mini"
            icon="el-icon-edit"
            style="margin-left: 5px;"
            @click="update(scope.row.id)"
          />
        </el-tooltip>
      </template>
    </el-table-column>

  </el-table>
</template>

<script>

  export default {

    props: ['items'],

    data() {
      return {
      };
    },

    async mounted() {
    },

    methods: {
      async update(id) {
        this.$router.push('/representative-processes/tour-calendar-rules/update/' + id);
      },
    }
  };
</script>

